import type { ReactNode } from "react";

type SectionTitleProps = {
  children: ReactNode;
};

export const SectionTitle = ({ children }: SectionTitleProps) => (
  <h3 className="text-lg font-semibold text-black">{children}</h3>
);
